import React from 'react';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';

interface IProps {
  operations: Operation[];
  operationsSelected: Operation[] | Operation;
  setSelectedOperations: (operationSelected: Operation[]) => void;
  initMarketingNotifications?: boolean;
}

// Runtime dependency
const FarmerNavigation: React.FC<IProps> = React.lazy(() => importFromS3('farmer-navigation'));

export const FarmerNav: React.FC<IProps> = ({
  operations,
  operationsSelected,
  setSelectedOperations,
}: IProps) => (
  <FarmerNavigation
    operations={operations}
    operationsSelected={operationsSelected}
    setSelectedOperations={setSelectedOperations}
    initMarketingNotifications={false}
  />
);
